export default "__VITE_ASSET__DSxEBwc8__"